module.exports = __webpack_public_path__ + "img/Khearts.43c1d97a.jpg";